import { render, staticRenderFns } from "./NovoMenu.vue?vue&type=template&id=a46118cc"
import script from "./NovoMenu.vue?vue&type=script&lang=js"
export * from "./NovoMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports